import { INumericReleaseItem } from '@planning/rt-stores/numericRelease/NumericReleaseItem'
import { PATHS } from '@tom-ui/utils'
import { observer } from 'mobx-react-lite'
import { useNavigate } from 'react-router'
import { ReleaseDetailsViewStore } from '../../../Stores/ReleaseDetailsViewStore'
import { ReleaseDetailsOptions } from '../../molecules/ReleaseDetailsOptions'

type Props = {
  numericRelease: INumericReleaseItem
  viewStore: ReleaseDetailsViewStore
}

export const NumericReleaseDetailsOptions = observer((props: Props) => {
  const { numericRelease, viewStore } = props
  const navigate = useNavigate()

  const { referenceNumber, shippingLineName } = numericRelease.data

  return (
    <ReleaseDetailsOptions
      tableRef={viewStore.tableRef}
      referenceNumber={referenceNumber}
      shippingLineName={shippingLineName}
      onEdit={() => navigate(`${PATHS.orders.numericReleases.url}/${numericRelease.id}`)}
    />
  )
})
